import { Button } from '@carvana/helios-navigation';
import { breakpoint } from '@carvana/helios-styles';
import Image from 'next/image';

import { useTestFunc } from '@carvana/test-attributes';
import { APP_BASE_PATH } from '../../shared/appBasePath';
import useAnalyticEvent from '../../shared/hooks/useAnalyticEvent';
import { useMediaQuery } from '../../shared/hooks/useMediaQuery';
import {
  ButtonContainer,
  ButtonWrapper,
  ContentWrapper,
  HeaderWrapper,
  ImageStyle,
  ImageWrapper,
  TextContainer,
  TextWrapper,
  TradeInWrapper
} from './TradeIn.styles';

type TradeInProps = {
  videoExperiment?: boolean;
};

const TradeIn = ({ videoExperiment }: TradeInProps) => {
  const { recordActionClicked } = useAnalyticEvent();
  const getTestAttributes = useTestFunc();

  const isMobile = useMediaQuery(`(max-width: ${breakpoint.sm})`);

  const getStarted = () => {
    recordActionClicked('Landing Page', 'Trade-in, Get Started');
  };

  const imageLoader = ({ src }: { src: string }) => {
    const appUrl = process.env.CARVANA_APP_PUBLIC_URL!;
    const prefix = appUrl.includes('localhost') ? appUrl : `${appUrl}/next`;
    return `${prefix}${src}.webp`;
  };

  const wizardRoute = `${APP_BASE_PATH}/getoffer/vehicle`;

  return (
    <TradeInWrapper>
      <ContentWrapper>
        <TextContainer>
          <HeaderWrapper className={videoExperiment ? '' : 'capitalize'}>
            Trade in and save on your purchase
          </HeaderWrapper>
          <TextWrapper>
            Save more when you trade in the car you have for the car you want. It’s easy and all
            online.
          </TextWrapper>
          <ButtonContainer>
            <ButtonWrapper>
              <a href={wizardRoute}>
                <Button
                  size={isMobile ? 'lg' : 'sm'}
                  variant="secondaryInverted"
                  onClick={getStarted}
                  {...getTestAttributes('GetStarted', 'TradeIn-GetStarted')}
                >
                  Get&nbsp;started
                </Button>
              </a>
            </ButtonWrapper>
          </ButtonContainer>
        </TextContainer>
        <ImageWrapper>
          <Image
            src="/images/HappyFamily"
            loader={imageLoader}
            alt="Get Your Offer"
            style={ImageStyle}
            fill
            sizes={`(max-width: ${breakpoint.md}) 100vw,
              (max-width: ${breakpoint.sm}) 50vw,
              33vw`}
          />
        </ImageWrapper>
      </ContentWrapper>
    </TradeInWrapper>
  );
};

export default TradeIn;
